// extracted by mini-css-extract-plugin
export default {"editModal":"EditPost_editModal__l2f9O","editModalContent":"EditPost_editModalContent__Y61Yr","saveBox":"EditPost_saveBox__h0ARi","cancel":"EditPost_cancel__bredO"};